<template>
  <header :class="headerClasses">
    <div class="grid grid--container">
      <nuxt-link class="header__logo" to="/">
        <Logo
          color="#465049"
          mark-color="primary"
          :size="isLargeScreen ? 30 : 26"
        />
      </nuxt-link>

      <nav class="header__nav">
        <ul class="header__nav-list">
          <template v-if="!isLoggedIn">
            <li class="header__nav-action">
              <Button
                href="https://app.campsite.bio/create-account"
                size="small"
                color="#465049"
                >Sign Up Free</Button
              >
            </li>
          </template>
          <template v-else>
            <li class="header__nav-action header__nav-action--first">
              <Button
                href="https://app.campsite.bio"
                size="small"
                color="#465049"
                >Account</Button
              >
            </li>
          </template>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import { getCookie } from '@/utils/cookies';
import { Button, Logo } from '@campsite-bio/component-lib';
import { useMediaQuery } from '@vueuse/core';

export default {
  components: {
    Button,
    Logo,
  },

  setup() {
    const isLargeScreen = useMediaQuery('(min-width: 544px)');

    return {
      isLargeScreen,
    };
  },

  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    headerClasses() {
      return {
        header: true,
        'show-menu': this.showMenu,
      };
    },
  },

  mounted() {
    if (process.client && getCookie('auth_token_')) {
      try {
        this.$store.dispatch('getUser');
      } catch (e) {
        // console.error(e);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.header {
  background: var(--g-color-light-green);
  color: var(--g-color-on-primary);
  height: 3.125rem;
  padding: 0;
  position: relative;
  z-index: 100;

  .grid {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: space-between;
  }
}

.header__logo {
  display: inline-flex;
  text-decoration: none;
}

.header__nav-list {
  list-style: none;
  margin: 0;
  padding-left: 0;
  display: flex;
}
</style>
